"use client"

import { toImageSrc } from "@/lib/utils"
import { EyeOutlined } from "@ant-design/icons"
import { Button, Image as AntdImage, Modal } from "antd"
import Image from "next/image"
import { useEffect, useState } from "react"
import { Media } from "../../../../../lib/external-components"

interface SlideItemProps {
  value?: string | undefined
  onChange?: (value: string) => void
  onMediaChange?: (url: string, id: number) => void
  hideUrl?: boolean
}

export const ImageUploadField = ({ value, onChange, onMediaChange, hideUrl }: SlideItemProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [url, setUrl] = useState(value || "")
  const [previewOpen, setPreviewOpen] = useState(false)

  useEffect(() => {
    setUrl(value || "")
  }, [value])

  const openModal = () => {
    setIsModalOpen(true)
  }

  const handleSelectMedia = (media: { id: number; url: string }) => {
    setUrl(media.url)
    onChange?.(media.url as any)
    onMediaChange?.(media.url, media.id)
    setIsModalOpen(false)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div className="flex flex-col gap-2">
      {!hideUrl && (
        <input
          type="text"
          value={url}
          onChange={e => onChange?.(e.target.value as any)}
          placeholder="Image URL"
          readOnly
        />
      )}
      <div className="relative cursor-pointer group w-fit flex items-center justify-center" onClick={() => openModal()}>

        <Image
          src={toImageSrc(url)}
          alt="Image"
          width={200}
          height={150}
          className="rounded-lg max-h-32 cursor-pointer transition duration-300 ease-in-out group-hover:blur-sm overflow-hidden object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 ease-in-out">
          <span className="text-white text-sm font-semibold drop-shadow-md">Change media</span>
        </div>
        {url && (
          <button
            type="button"
            title="Xem ảnh"
            className="absolute top-1 right-1 z-10 w-7 h-7 flex items-center justify-center rounded-full bg-black/50 text-white opacity-0 group-hover:opacity-100 transition-opacity"
            onClick={e => {
              e.stopPropagation()
              setPreviewOpen(true)
            }}
          >
            <EyeOutlined />
          </button>
        )}
      </div>

      {url && (
        <AntdImage
          style={{ display: "none" }}
          src={toImageSrc(url)}
          preview={{
            visible: previewOpen,
            src: toImageSrc(url),
            onVisibleChange: visible => setPreviewOpen(visible),
          }}
        />
      )}

      <Button
        onClick={() => openModal()}
        type="default"
        variant="outlined"
        className="bg-blue text-white p-2 border-[1px] border-blue rounded-md hover:bg-blue-800 hover:text-white duration-300"
      >
        {url ? "Change Media" : "Select Media"}
      </Button>

      <Modal
        open={isModalOpen}
        title={<span className="ml-4">Select Media</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div>
          <Media
            isOpenModal={true}
            onSelectMedia={media => handleSelectMedia(media as { id: number; url: string })}
          />
        </div>
      </Modal>
    </div>
  )
}
